import { BackButton } from 'foundations-components/transitional/components/BackButton';
import { Link } from 'foundations-components/transitional/components/Link';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent } from 'marketplace-ui-tracking/events/marketplace';
import { jsx as _jsx } from "react/jsx-runtime";
export function RouteReferrerBackLink({
  onClick,
  referrer
}) {
  const trackMarketplaceEvent = useTrackMarketplaceEvent(true);
  return /*#__PURE__*/_jsx(BackButton, {
    children: /*#__PURE__*/_jsx(Link, {
      href: referrer.referrerUrl,
      "data-test-id": "storefront-referrer-back-link",
      onClick: evt => {
        onClick === null || onClick === void 0 || onClick(evt);
        trackMarketplaceEvent(getMarketplaceInteractionEvent({
          action: 'referrer back link clicked'
        }));
      },
      children: referrer.linkText
    })
  });
}